React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'AttachmentRestrictionsComponent'

  render: t.renderable ->
    { attachmentRestrictions } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        t.p ->
          t.format 'allowed-attachment-types'
        t.ul ->
          for attachmentType in attachmentRestrictions.enabled
            t.li ->
              t.strong ->
                t.format attachmentType
        if attachmentRestrictions.disabled.length
          t.br()
          t.p ->
            t.format 'prohibited-attachment-types'
          t.ul ->
            for attachmentType in attachmentRestrictions.disabled
              t.li ->
                t.strong ->
                  t.format attachmentType




// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/attachment-restrictions-component.coffee